<div class="p-grid categoriesConfig">
    <div [ngClass]="{'p-col-4 p-md-4 p-lg-4': isAdmin}">
        <!-- only for admin area -->
        <div *ngIf="isAdmin">
            <input type="text" [(ngModel)]="category.name" pInputText
                placeholder="{{'create_new_category' | translate}}">
            <button label="save" [disabled]="saving" pButton (click)="onSaveCategory()" style="margin-left: 5px;"
                label="{{'create_new_category_btn' | translate}}"> </button>
            <br />

            <br /><br />
        </div>
        <!-- end only for admin area -->

        <p-tree (onNodeSelect)="nodeSelect($event)" (onNodeUnselect)="nodeSelect($event)" [draggableNodes]="editMode"
            droppableNodes="true" [validateDrop]="true" (onNodeDrop)="onDropC($event)"
            [(selection)]="selectedCategories" [value]="categoryTreeList" selectionMode="multiple">
            <ng-template let-node pTemplate="default">

                <section dndDropzone [ngClass]="{'onDragover': node.onDragover}" (dndDrop)="onDrop($event, node)"
                    (dndDragover)="onDragover($event, node)">
                    <input *ngIf="node.edit" [(ngModel)]="node.name" type="text" style="width:100%">
                    <div *ngIf="!node.edit ">{{node.name}} <span *ngIf="isAdmin">({{node.count}})</span></div>
                    <div class="link inline" *ngIf="editMode && isAdmin" (click)="onChangeNode(node)">
                        {{'category_tree_change' | translate}}</div>
                        <div class="link inline" *ngIf="editMode && isAdmin" (click)="onRemoveNode(node)">{{'usuń'}}</div>
                        <div class="link inline" *ngIf="editMode && isAdmin" (click)="onResetNode(node)">{{'zresetuj'}}</div>
                        <input class="inline orderInput" *ngIf="editMode && isAdmin" type="number"  [(ngModel)]="node.orderIndex" (change)="editOrder(node)" />
                </section>
                <!-- <div class="link inline" *ngIf="editMode && isAdmin">{{'category_tree_delete' | translate}}</div> -->
            </ng-template>
        </p-tree>

        <br />
        <button pButton label="{{'editMode_off' | translate}}" *ngIf="!editMode && isAdmin" (click)="onEdit(true)"
            class="ui-button-secondary"></button>
        <button pButton label="{{'editMode_on' | translate}}" *ngIf="editMode && isAdmin" (click)="onEdit(false)"
            class="ui-button-secondary"></button>

    </div>

    <div *ngIf="isAdmin" [ngClass]="{'p-col-8 p-md-8 p-lg-8': isAdmin}">

        <app-loader *ngIf="this.loadingNotes"></app-loader>
        <div *ngIf="this.notes.length == 0" style="display: flex;justify-content: center;">Brak nut w wybranej kategorii
        </div>
        <div style="display: flex;flex-wrap: wrap;">
            <div *ngFor="let note of this.notes; index as i;" style="width: 25% ">
                <div style="margin: 0 5px 5px 0">
                    <div style="padding:10px 15px;display: block;border:1px solid #ddd;margin-bottom:3px;cursor: move;"
                        [dndDraggable]="note" [dndEffectAllowed]="draggable.effectAllowed" (dndEnd)="onDragEnd($event)">
                        <div style="display: flex;flex-wrap: nowrap;">
                            <div>{{i+1}}. {{note.title}}</div>
                            <div style="display: flex;justify-content: flex-end;flex-grow: 1;">
                                <a href="#" (click)="onDeleteElementFromCategory($event, note)">
                                    <i class="pi pi-times"></i>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<p-dialog (onHide)="closeEditNode()" [(visible)]="displayEditNode">
    <input *ngIf="editedNode" type="text" pInputText [(ngModel)]="editedNode.name">
    <button (click)="onEditNode(editedNode)" pButton label="{{'category_tree_change' | translate}}"></button>
</p-dialog>




<p-dialog [(visible)]="visibleConfirmMoveOrCopy">
    <p-header>Akcja</p-header>
    Czy chcesz skopiować lub przenieść <span style="font-weight: bold;">{{this.elementDrop?.title}}</span> do <span
        style="font-weight: bold;">{{this.elementDragover?.name}}</span>?
    <p-footer>
        <button (click)="onCopyElement()" type="button" pButton icon="pi pi-info-circle" label="Kopiuj"></button>
        <button (click)="onMoveElement()" type="button" pButton icon="pi pi-info-circle" label="Przenieś"></button>
    </p-footer>
</p-dialog>
